import axios from 'axios'

import { authorizationCheck } from './auth.service'
import { Outcome } from './Model/Outcome'

const { REACT_APP_EM_API_URL } = process.env

export const mockActivities = [
	{
		id: 46,
		activity_group_id: 46,
		name: 'Quality Engineer Training',
		startDate: null,
		endDate: null,
		enrolling: 0,
	},
	{
		id: 1,
		activity_group_id: 1,
		name: 'Delattre',
		startDate: '2015-10-11T12:59:59.000Z',
		endDate: '2018-05-31T20:24:54.000Z',
		enrolling: 0,
	},
	{
		id: 2,
		activity_group_id: 2,
		name: 'Lange',
		startDate: '2015-10-06T12:59:59.000Z',
		endDate: '2018-05-31T20:24:54.000Z',
		enrolling: 0,
	},
	{
		id: 3,
		activity_group_id: 3,
		name: 'Hänel e.G.',
		startDate: '2013-09-06T12:59:59.000Z',
		endDate: '2018-05-31T20:24:54.000Z',
		enrolling: 1,
	},
	{
		id: 4,
		activity_group_id: 4,
		name: 'Lago-Gomila',
		startDate: '2016-10-11T12:59:59.000Z',
		endDate: '2018-05-31T20:24:54.000Z',
		enrolling: 0,
	},
	{
		id: 5,
		activity_group_id: 5,
		name: 'Marchal',
		startDate: '2015-10-12T12:59:59.000Z',
		endDate: '2018-05-31T20:24:54.000Z',
		enrolling: 1,
	},
	{
		id: 6,
		activity_group_id: 6,
		name: 'Sauer Steckel KGaA',
		startDate: '2015-01-10T12:59:59.000Z',
		endDate: '2018-05-31T20:24:54.000Z',
		enrolling: 0,
	},
	{
		id: 234,
		activity_group_id: 234,
		name: 'Quality Engineer Training',
		startDate: '2015-04-03T12:59:59.000Z',
		endDate: '2018-05-31T20:24:54.000Z',
		enrolling: 0,
	},
	{
		id: 35,
		activity_group_id: 35,
		name: 'Delattre',
		startDate: '2015-10-11T12:59:59.000Z',
		endDate: '2018-05-31T20:24:54.000Z',
		enrolling: 0,
	},
	{
		id: 423,
		activity_group_id: 423,
		name: 'Lange',
		startDate: '2015-10-06T12:59:59.000Z',
		endDate: '2018-05-31T20:24:54.000Z',
		enrolling: 0,
	},
	{
		id: 93,
		activity_group_id: 93,
		name: 'Hänel e.G.',
		startDate: '2013-09-06T12:59:59.000Z',
		endDate: '2018-05-31T20:24:54.000Z',
		enrolling: 1,
	},
	{
		id: 134,
		activity_group_id: 134,
		name: 'Lago-Gomila',
		startDate: '2016-10-11T12:59:59.000Z',
		endDate: '2018-05-31T20:24:54.000Z',
		enrolling: 0,
	},
	{
		id: 675,
		activity_group_id: 675,
		name: 'Marchal',
		startDate: '2015-10-12T12:59:59.000Z',
		endDate: '2018-05-31T20:24:54.000Z',
		enrolling: 1,
	},
	{
		id: 676,
		activity_group_id: 676,
		name: 'Sauer Steckel KGaA',
		startDate: '2015-01-10T12:59:59.000Z',
		endDate: '2018-05-31T20:24:54.000Z',
		enrolling: 0,
	},
]
const MOCK_PARTICIPANTS = [
	{
		id: '1',
		participantId: '123',
		firstName: 'Eldredge',
		lastName: 'Bracher',
		enrollmentDate: new Date('2017-05-03T05:00:00.000Z'),
		outcomeActualStartDate: new Date('2017-05-03'),
    quest: 1,
		status: 'Enrolled',
	},
	{
		id: '2',
		participantId: '132',
		firstName: 'Cameron',
		lastName: 'Andrea',
    quest: 0,
		status: 'Completed',
    enrollmentDate: new Date('2017-05-03T22:00:00.000Z'),
		outcomeActualStartDate: new Date('2017-05-03'),
	},
	{
		id: '6',
		participantId: '13',
		firstName: 'Roca',
		lastName: 'Adelbert',
		status: 'Enrolled',
    enrollmentDate: new Date('2017-05-03T00:00:00.000Z'),
		outcomeActualStartDate: new Date('2017-05-03'),
	},
	{
		id: '123',
		participantId: '31',
		firstName: 'Guzmán',
		lastName: 'Jose',
		status: 'Completed',
    enrollmentDate: new Date('2017-05-02T22:00:00.000Z'),
		outcomeActualStartDate: new Date('2017-05-03'),
	},
	{
		id: '32',
		participantId: '51',
		firstName: 'Eigenwillig',
		lastName: 'Nerea',
		status: 'Dropped Out',
    enrollmentDate: new Date('2017-05-04T00:00:00.000Z'),
		outcomeActualStartDate: new Date('2017-05-07'),
	},
	{
		id: '87',
		participantId: '86',
		firstName: 'Stey',
		lastName: 'Rust',
		status: 'Enrolled',
    enrollmentDate: new Date('2017-05-04T00:00:00.000Z'),
		outcomeActualStartDate: new Date('2017-05-06'),
	},
	{
		id: '53',
		participantId: '6',
		firstName: 'Frédérique',
		lastName: 'Boulanger',
		status: 'Dropped Out',
    enrollmentDate: new Date('2017-05-04T00:00:00.000Z'),
		outcomeActualStartDate: new Date('2017-05-05'),
	},
]
const MOCK_SINGLE_PARTICIPANT_INFO1 = {
	address1: '88 Shelley Parkway',
	address2: null,
	citizen: true,
	city: 'Lais',
	dateOfBirth: '1939-09-23T06:56:01.000Z',
	education: 'PHD',
	ell: true,
	email: 'jBurt@email.com',
	employer: 'Employer 1',
	employmentType: 'FULL_TIME',
	ethnicity: 'LATINO',
	familyDependent: false,
	firstName: 'Junette',
	gender: 'FEMALE',
	higherWages: false,
	highestGrade: 9,
	homeless: false,
	attendingSchool: false,
	laidOff: false,
	lastName: 'Burl',
	layoffDate: '1939-09-23T06:56:01.000Z',
	layoffEmployer: 'The Layoff Employer',
	mailingAddress1: null,
	mailingAddress2: null,
	mailingCity: null,
	mailingState: null,
	mailingZip: null,
	middleInitial: null,
	phoneNumber: '3942425574',
	races: ['WHITE'],
	skills: false,
	state: 'RI',
	veteran: false,
	working: false,
	zip: '02889',
  quest: 1
}
const MOCK_TARGETS = [
	{
		id: '1',
		activityID: '1',
		placed: '10',
		completed: '11',
		enrolled: '12',
	},
	{
		id: '2',
		activityID: '2',
		placed: '13',
		completed: '14',
		enrolled: '15',
	}
]
export const getAllEMActivities = async () => {
	if (process.env.NODE_ENV !== 'production') {
    const dummypk = 'PQRBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlpAYtdoUFl4EVDWsl1fNsXjr96eyneHC6UZcb+wtKEP/L4J/k3Y2qspNdVxrz5+xiR2avvC94wMI1ZdYy4VgBFxQ838lSRQMFO7VlQO/7rklR835JtsRwEzQ1jk2lql323N0GZ/Z5tsigRi1oqTedzDmMWzba1PXszVA4uA6MUzlskCw5mbwxZlBSieDaTat/PR/f40UqZ6HcfZLgsvAl5AB4eHcQ7egui7BesPbWBnfKndhfRFhHtonAGUlXliBXFpFK7MeW55XaudPIJbLO4geEji4Ta2rCgh7CFIAMa6ylCUZwpT0aVohpz47f3vCld23NM9LI91ol5TJrrsvMQIDAQXYZ'
		return await {activities:mockActivities, pk:dummypk}
	} else {
		try {
			const { data, status } = await axios.get(`${REACT_APP_EM_API_URL}/activities` || '/')
			authorizationCheck(status)
			return data
		} catch (e:any) {
			throw new Error(e)
		}
	}
}

export const getActivityById = async (id: string) => {
	if (process.env.NODE_ENV !== 'production') {
		const obj = {
			"1": {
				serviceType: "JOB_SEARCH_PLACEMENT_ASSISTANCE",
				participantType: "JOBSEEKERS_NEW_HIRES",
			},
			"2": {
				serviceType: "WORKFORCE_TRAINING",
				participantType: "OTHER_ENROLLED",
			},
			"3": {
				serviceType: "WORKFORCE_TRAINING",
				participantType: "INCUMBENT_WORKERS",
			},
			"4": {
				serviceType: "INTERNSHIPS_WORK_BASED_LEARNING",
				participantType: "OTHER_ENROLLED",
			},
			"5": {
				serviceType: "WORKFORCE_TRAINING",
				participantType: "BUSINESS_OWNERS_ENTREPRENEURS",
			},
			"6": {
				serviceType: "GENERAL_EDUCATION",
				participantType: "OTHER_ENROLLED",
			},
			"7": {
				serviceType: 'CAREER_EXPLORATION_ESSENTIAL_SKILLS',
				participantType: 'OTHER_ENROLLED',
			},
			"8": {
				serviceType: 'CAREER_EXPLORATION_ESSENTIAL_SKILLS',
				participantType: 'NON_ENROLLED'
			}
		}

		const GetMockServiceAndParticipantType = (itemId: string) => {
			return (
				obj[itemId] || {
					participantType: 'JOBSEEKERS_NEW_HIRES',
					serviceType: 'WORKFORCE_TRAINING',
				}
			)
		}

		const { participantType, serviceType } = GetMockServiceAndParticipantType("4")

		return await {
			enrolling: 1,
			id: 1,
			name: "Test Activity Group 1 Test Activity 1",
			participantType,
			serviceType,
			partnershipName: "Partnership number 1",
			addendumName: "Addendum number 1"
		}
	} else {
		try {
			const { data, status } = await axios.get(`${REACT_APP_EM_API_URL}/activities/${id}` || '/')
			authorizationCheck(status)
			return data
		} catch (e:any) {
			throw new Error()
		}
	}
}

export const getActivityActualsByActivityID = async (id: string) => {
	if (process.env.NODE_ENV !== 'production') {
		return await MOCK_TARGETS
	} else {
		try {
			const { data, status } = await axios.get(`${REACT_APP_EM_API_URL}/activities/${id}/targets` || '/')

			authorizationCheck(status)
			return data
		} catch (e:any) {
			authorizationCheck(e.response.status)
			throw new Error(e)
		}
	}
}

export const getParticipantsByActivityId = async (id: string) => {
	if (process.env.NODE_ENV !== 'production') {
		return await MOCK_PARTICIPANTS
	} else {
		try {
			const { data, status } = await axios.get(`${REACT_APP_EM_API_URL}/activities/${id}/participants` || '/')

			authorizationCheck(status)
			return data
		} catch (e:any) {
			authorizationCheck(e.response.status)
			throw new Error(e)
		}
	}
}

export const getParticipantInfoById = async (activityID: string, participantID: string) => {
	if (process.env.NODE_ENV !== 'production') {
		return await MOCK_SINGLE_PARTICIPANT_INFO1
	} else {
		try {
			const { data, status } = await axios.get(
				`${REACT_APP_EM_API_URL}/activities/${activityID}/participants/${participantID}` || '/',
			)

			authorizationCheck(status)
			return data
		} catch (e:any) {
			throw new Error(e)
		}
	}
}

export const getOutcome = async (activityID: string, participantID: string) => {
	try {
		const url = `${REACT_APP_EM_API_URL}/activities/${activityID}/participants/${participantID}/outcome`

		const { data, status } = await axios.get(url)

		authorizationCheck(status)
		return data
	} catch (e:any) {
		throw new Error(e)
	}
}

export const updateOutcome = async (activityID: string, participantID: string, outcomeData: Outcome) => {
	try {
		const url = `${REACT_APP_EM_API_URL}/activities/${activityID}/participants/${participantID}/outcome`

		const { data, status } = await axios.put(url, outcomeData)

		authorizationCheck(status)
		return data
	} catch (e:any) {
		throw new Error(e)
	}
}
